import axios from "axios";
export default {
  data() {
    return {
      weburl: "https://www.rayscloud.cn/webapi",
      siteId: "",
      menuId: "",
      childId: 0,
      navList: [],
      contlist: [],
      current: 54
    };
  },
  methods: {
    getchild() {
      axios
        .get(`${this.weburl}/api/Site/Menu/list/${this.siteId}/${this.menuId}`)
        .then(res => {
          if (res.status == 200) {
            this.navList = res.data.data;
            if (this.navList.length > 0) {
              if (this.childId == 0) {
                this.childId = this.navList[0].serId;
              }
              setTimeout(() => {
                this.getchild2();
              }, 250);
            }
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    setmenuId(serId) {
      this.childId = serId;
      this.current = serId;
      localStorage.setItem("childId", this.childId);
      this.getchild2();
    },
    getchild2() {
      axios
        .get(`${this.weburl}/api/Site/Menu/${this.siteId}/${this.childId}`)
        .then(res => {
          if (res.status == 200) {
            localStorage.setItem("childId", this.childId);
            this.contlist = res.data.data;
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    goInfo(item) {
      localStorage.setItem("secondMenu", JSON.stringify(item));
      this.$router.push(item.link);
    }
  },
  created() {
    let query = this.$route.query;
    this.siteId = query.siteId ? query.siteId : localStorage.getItem("siteId");
    this.menuId = query.menuId ? query.menuId : localStorage.getItem("menuId");
    this.childId = query.childId
      ? query.childId
      : localStorage.getItem("childId");
    if (this.childId == null) {
      this.childId = 0;
    }
    this.current = this.childId;
    this.getchild();
  }
};
